import { BankDetails } from "../models/BankDetails";
import { MaterialData } from "../models/MaterialData";
import { Company } from "../models/Company";
import { Department } from "../models/Department";
import { HouseBank } from "../models/HouseBank";
import { PaymentMethod } from "../models/PaymentMethod";
import { PaymentPurpose } from "../models/PaymentPurpose";
import { RegionCode } from "../models/RegionCode";
import { RequestType } from "../models/RequestType";
import { SortCode } from "../models/SortCode";
import { PaymemntBlock } from "../models/VendorBlocking/PaymemntBlock";
import { VendorDetailBankDetailMeta } from "../models/VendorDetail/VendorDetailBankDetailMeta";
import { VendorDetailBasicMeta } from "../models/VendorDetail/VendorDetailBasicMeta";
import { VendorDetailContactMeta } from "../models/VendorDetail/VendorDetailContactMeta";
import { VendorDetailPaymentMeta } from "../models/VendorDetail/VendorDetailPaymentMeta";
import { PurposeOfPayment } from "../models/PurposeOfPayment";
import { WHTCode } from "../models/WHTCode";
import { WHTType } from "../models/WHTType";
import { AxiosConfig } from "./AxiosConfig";
import { CurrencyHouseBank } from "../models/AccCurency";
import { UOM } from "../models/UOM";
import { CommonRef } from "../models/CommonRef";
import { CategoryManagedBy } from "../models/Master/CategoryManagedBy";

const getCompanyCodes = async (
  successCallback: (sbuList: Array<Company>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetAllCompanyCodes`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getDepartments = async (
  successCallback: (sbuList: Array<Department>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetDepartments`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetSAPVendorList = async (
  filterData: any,
  successCallback: (resposeObj: any) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("VendorMasterData/GetSapVendors", {
      params: filterData,
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetRequestTypes = async (
  successCallback: (vendorTypesData: Array<RequestType>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetRequestType");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetPaymentBolcks = async (
  successCallback: (paymntBlockData: Array<PaymemntBlock>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetPaymentBolcks");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getPurposeOfPaymentData = async (
  successCallback: (purposeOfpaymentData: Array<PaymentPurpose>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetPaymentPurpose`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getRegionCode = async (
  countryCode: string,
  successCallback: (regionData: Array<RegionCode>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetRegion", {
      params: { countryCode: countryCode },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getWHTTypes = async (
  countryCode: string,
  successCallback: (whttypes: Array<WHTType>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetWhtTypes", {
      params: { countryCode: countryCode },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getWHTCodes = async (
  countryCode: string,
  successCallback: (whttypes: Array<WHTCode>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetWhtCodes", {
      params: { countryCode: countryCode },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

// const getBankAcKeys = async (
//   countryCode:string,
//   successCallback: (whttypes: Array<BankKey>) => void,
//   errorCallback: (error: Error) => void
// ) => {
//   try {
//     const resp = await AxiosConfig.get("/VendorMasterData/GetBackAcKeys", {
//       params : { countryCode : countryCode},
//     });
//     successCallback(resp.data);
//   } catch (err: any) {
//     // Handle Error Here
//     console.error(err);
//     errorCallback(err);
//   }
// };

const getBankDetails = async (
  countryCode: string,
  successCallback: (bankDetail: Array<BankDetails>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetBackDetails", {
      params: { countryCode: countryCode },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getPreferedPaymentMethods = async (
  companyCode: string,
  countryCode: string,
  successCallback: (paymentData: Array<PaymentMethod>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    // const resp = await AxiosConfig.get("/VendorMasterData/GetPreferedPaymentMethods", {
    //   params : { companyCode : companyCode},
    // });
    const resp = await AxiosConfig.get(
      `/VendorMasterData/GetPreferedPaymentMethods?companyCode=${companyCode}&countryCode=${countryCode}`
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getHouseBank = async (
  companyCode: string,
  successCallback: (houseBankList: Array<HouseBank>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetHouseBank", {
      params: { companyCode: companyCode },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getBasicDetailMetaData = async (
  successCallback: (basicData: VendorDetailBasicMeta) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetBasicInformationLists");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getContactDetailMetaData = async (
  successCallback: (contactData: VendorDetailContactMeta) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetContactDetailLists");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getUOMMetaData = async (
  successCallback: (uomList: Array<UOM>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetUOM");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getPaymentDetailMetaData = async (
  compnayCountryCode: string,
  successCallback: (paymentData: VendorDetailPaymentMeta) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetPaymentDetailLists?countryCode=${compnayCountryCode}`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getBankDetailMetaData = async (
  successCallback: (bankData: VendorDetailBankDetailMeta) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetBankDetaillLists`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getSortKeyData = async (
  successCallback: (sortKeyList: Array<SortCode>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetSortKeys");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
const getPurposeOfPaymentIndiaData = async (
  successCallback: (purposeOfPayementList: Array<PurposeOfPayment>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetPurposeOfPaymentIndia`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getCurrencyHouseBankMapping = async (
  successCallback: (purposeOfPayementList: Array<CurrencyHouseBank>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/GetCurrencyHouseBankMapping`);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const validateMaterialRef = async (
  materialRef: string,
  successCallback: (data: MaterialData) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(`/VendorMasterData/ValidateMaterialRef`,{
      params: { materialRef: materialRef },
    });
     
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getSpendManagedBy = async (
  successCallback: (list: Array<CommonRef>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetSpendManagedBy");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
const getCategoryManagedBy = async (
  successCallback: (list: Array<CategoryManagedBy>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/VendorMasterData/GetSpendManagedBy");
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

export const VendorMasterData = {
  getCompanyCodes,
  GetSAPVendorList,
  GetRequestTypes,
  GetPaymentBolcks,
  getPurposeOfPaymentData,
  getRegionCode,
  getPreferedPaymentMethods,
  getWHTTypes,
  getWHTCodes,
  // getBankAcKeys
  getBankDetails,
  getHouseBank,
  getBasicDetailMetaData,
  getContactDetailMetaData,
  getPaymentDetailMetaData,
  getBankDetailMetaData,
  getSortKeyData,
  getPurposeOfPaymentIndiaData,
  getDepartments,
  getCurrencyHouseBankMapping,
  getUOMMetaData,
  validateMaterialRef,
  getSpendManagedBy,
  getCategoryManagedBy
};
